import React from "react";
import styled, { keyframes } from "styled-components";

const shimmer = keyframes`
  0% {
    background-position: -1000px 0;
  }
  100% {
    background-position: 1000px 0;
  }
`;

const SkeletonWrapper = styled.div`
  background: #f5f5f5;
  min-height: 600px;
  display: flex;
  align-items: center;
  position: relative;
  overflow: hidden;

  @media (max-width: 768px) {
    min-height: 500px;
  }

  @media (max-width: 576px) {
    min-height: 400px;
  }
`;

const SkeletonContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  width: 100%;
  display: flex;
  align-items: center;
  gap: 40px;
  position: relative;
  z-index: 2;

  @media (max-width: 768px) {
    gap: 20px;
    padding: 0 20px;
    align-items: center;
  }
`;

const SkeletonContent = styled.div`
  flex: 1;
  padding: 60px 0;

  @media (max-width: 768px) {
    padding: 40px 0;
  }

  @media (max-width: 576px) {
    padding: 30px 0;
  }
`;

const SkeletonLine = styled.div`
  background: linear-gradient(90deg, #e0e0e0 25%, #f0f0f0 50%, #e0e0e0 75%);
  background-size: 1000px 100%;
  animation: ${shimmer} 2s infinite;
  border-radius: 4px;
  margin-bottom: ${(props) => props.marginBottom || "20px"};
  height: ${(props) => props.height || "16px"};
  width: ${(props) => props.width || "100%"};
`;

const SkeletonSubtitle = styled(SkeletonLine)`
  width: 150px;
  height: 14px;
  margin-bottom: 30px;

  @media (max-width: 768px) {
    width: 120px;
    margin-bottom: 15px;
  }
`;

const SkeletonTitle = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 50px;

  @media (max-width: 768px) {
    margin-bottom: 30px;
    gap: 8px;
  }

  @media (max-width: 576px) {
    gap: 6px;
  }
`;

const SkeletonTitleLine = styled(SkeletonLine)`
  height: 48px;

  @media (max-width: 768px) {
    height: 32px;
  }

  @media (max-width: 576px) {
    height: 24px;
  }
`;

const SkeletonButton = styled(SkeletonLine)`
  width: 180px;
  height: 20px;
  margin-bottom: 0;

  @media (max-width: 768px) {
    width: 150px;
    height: 18px;
  }

  @media (max-width: 576px) {
    width: 130px;
    height: 16px;
  }
`;

const SkeletonDot = styled.div`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: linear-gradient(90deg, #e0e0e0 25%, #f0f0f0 50%, #e0e0e0 75%);
  background-size: 1000px 100%;
  animation: ${shimmer} 2s infinite;
`;

const CarouselNavSkeleton = styled.div`
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 12px;
  z-index: 10;
`;

const BannerSkeleton = () => {
  return (
    <SkeletonWrapper>
      <SkeletonContainer>
        <SkeletonContent>
          <SkeletonSubtitle />
          <SkeletonTitle>
            <SkeletonTitleLine width="80%" />
            <SkeletonTitleLine width="85%" />
          </SkeletonTitle>
          <SkeletonButton />
        </SkeletonContent>
      </SkeletonContainer>

      <CarouselNavSkeleton>
        {[1, 2, 3].map((i) => (
          <SkeletonDot key={i} />
        ))}
      </CarouselNavSkeleton>
    </SkeletonWrapper>
  );
};

export default BannerSkeleton;
